export enum QueryParamsTypes {
  GET_QUERY_PARAMS = '@queryParams/GET_QUERY_PARAMS',
  SAVE_QUERY_PARAMS = '@queryParams/SAVE_QUERY_PARAMS',
  RESET_REDUCER_QUERY_PARAMS = '@queryParams/RESET_REDUCER_QUERY_PARAMS'
}

export interface QueryParamsData {
  [key: string]: string;
}
export interface QueryParamsState {
  readonly queryParams: {
    data: QueryParamsData | null;
  };
}

export interface GetQueryParams {
  type: typeof QueryParamsTypes.GET_QUERY_PARAMS;
  payload: { route: string };
}

export interface SaveQueryParams {
  type: typeof QueryParamsTypes.SAVE_QUERY_PARAMS;
  payload: {
    data: QueryParamsData | null;
    route: string;
  };
}

export interface ResetReducerQueryParams {
  type: typeof QueryParamsTypes.RESET_REDUCER_QUERY_PARAMS;
}

export type QueryParamsActionTypes =
  | GetQueryParams
  | SaveQueryParams
  | ResetReducerQueryParams;

